import hasKey from 'onyx-common/hasKey'

const associateServices = (services, { store }) => {
  if (hasKey(services, 'vibeApi')) services['vibeApi'].setStore(store)
  if (hasKey(services, 'kwivrrApi')) services['kwivrrApi'].setStore(store)
}

export default associateServices
